import React, { useEffect, useRef } from 'react';
import { cn } from '../../../../../utils/tailwind';

interface CompoundInterestSummaryValueProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export const CompoundInterestSummaryValue = ({ children, className, style }: CompoundInterestSummaryValueProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const textRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const container = containerRef.current;
        const text = textRef.current;
        if (!container || !text) return undefined;
        let active = true;

        const fit = () => {
            if (!active || !container.clientWidth) return;
            text.style.fontSize = 'inherit';
            const preferredSize = parseFloat(window.getComputedStyle(container).fontSize);
            const textWidth = text.getBoundingClientRect().width;
            if (textWidth > container.clientWidth) {
                text.style.fontSize = `${Math.floor((preferredSize * container.clientWidth * 0.99) / textWidth)}px`;
            }
        };

        const observer = new ResizeObserver(fit);
        observer.observe(container);
        fit();
        document.fonts.ready.then(fit);
        return () => {
            active = false;
            observer.disconnect();
        };
    }, [children]);

    return (
        <div ref={containerRef} className={cn('min-w-0', className)} style={style}>
            <span ref={textRef} className="inline-block whitespace-nowrap">
                {children}
            </span>
        </div>
    );
};
